import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Container,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { PostAdd, AdminPanelSettings, Settings } from "@mui/icons-material";

const Homepage = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ textAlign: "center", py: 8 }}>
        <Typography variant="h2" component="h1" gutterBottom>
          Welcome to Counter.quest
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom color="text.secondary">
          Track Your Life Stats with Colorful Counters
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, maxWidth: 600, mx: "auto" }}>
          Monitor streaks, collect numeric data, and journal your progress.
          Track days since events, record happiness scores, or keep a daily diary.
          All your personal metrics in one beautiful dashboard.
        </Typography>

        <Grid container spacing={4} sx={{ mt: 4 }}>
          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%" }}>
              <CardContent sx={{ textAlign: "center", p: 3 }}>
                <PostAdd sx={{ fontSize: 48, color: "primary.main", mb: 2 }} />
                <Typography variant="h6" component="h3" gutterBottom>
                  Day Streak Counters
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Track days since last occurrence. Perfect for monitoring habits
                  like "days since smoking" or "days streak of exercise".
                </Typography>
                <Button
                  component={RouterLink}
                  to="/counters"
                  variant="contained"
                  size="small"
                >
                  View Counters
                </Button>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%" }}>
              <CardContent sx={{ textAlign: "center", p: 3 }}>
                <AdminPanelSettings sx={{ fontSize: 48, color: "primary.main", mb: 2 }} />
                <Typography variant="h6" component="h3" gutterBottom>
                  Number Tracking
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Record numeric values over time. Track happiness scores (1-10),
                  weight, or any quantifiable metric with automatic averaging.
                </Typography>
                <Button
                  component={RouterLink}
                  to="/counters"
                  variant="outlined"
                  size="small"
                >
                  Start Tracking
                </Button>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%" }}>
              <CardContent sx={{ textAlign: "center", p: 3 }}>
                <Settings sx={{ fontSize: 48, color: "primary.main", mb: 2 }} />
                <Typography variant="h6" component="h3" gutterBottom>
                  Journal & Notes
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Keep a text-based journal with entries. Perfect for daily
                  notes, gratitude logs, or any written records.
                </Typography>
                <Button
                  component={RouterLink}
                  to="/counters"
                  variant="outlined"
                  size="small"
                >
                  Start Writing
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box sx={{ mt: 6, p: 3, bgcolor: "background.paper", borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom>
            Getting Started
          </Typography>
          <Typography variant="body2" color="text.secondary">
            1. Sign in with Google to create your account<br />
            2. Create your first counter with a name and color<br />
            3. Track your progress and view detailed statistics over time
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Homepage; 